import { createGlobalStyle } from "styled-components";

export const OldComponentLibraryStyles = createGlobalStyle`
  :root {
    color-scheme: dark;
    --semantic-primary-text: #ff4e00;
    --semantic-primary-bg: #5d463d;
    --semantic-primary-bg-hover: #ff6e2e;
    --semantic-primary-icon: #ff4e00;
    --semantic-primary-bg-weaker: #5c1c00;
    --semantic-primary-bg-weakest: #401300;
    --semantic-secondary-bg: #77acba;
    --semantic-secondary-bg-hover: #94bec9;
    --semantic-secondary-bg-weaker: #27454d;
    --semantic-secondary-bg-weakest: #1d343a;
    --semantic-background-base: #111;
    --semantic-background-middle: #222;
    --semantic-background-top: #303030;
    --semantic-background-raised: #222;
    --semantic-text-normal: #fff;
    --semantic-text-weak: #d5d5d5;
    --semantic-text-weaker: #a6a6a6;
    --semantic-text-disabled: #888;
    --semantic-text-inverse: #111;
    --semantic-icon-normal: #fff;
    --semantic-icon-weak: #d5d5d5;
    --semantic-icon-weaker: #a6a6a6;
    --semantic-icon-disabled: #888;
    --semantic-icon-inverse: #111;
    --semantic-icon-hover: hsla(0, 0%, 100%, 0.078);
    --semantic-icon-inverse-hover: rgba(0, 0, 0, 0.078);
    --semantic-gray-bg-weakest: #111;
    --semantic-gray-bg-weakest-hover: #222;
    --semantic-gray-bg-weaker: #1a1a1a;
    --semantic-gray-bg-weak: #303030;
    --semantic-gray-bg-disabled: #303030;
    --semantic-gray-bg-medium: #474747;
    --semantic-gray-bg: #888;
    --semantic-gray-bg-strong: #e7e7e7;
    --semantic-gray-bg-strong-hover: #fff;
    --semantic-gray-bg-strongest: #fff;
    --semantic-bdr-normal: #2e2e2e;
    --semantic-bdr-inverse: #111;
    --semantic-bdr-weak: #474747;
    --semantic-bdr-strong: #5e5e5e;
    --semantic-bdr-focus: #fff;
    --semantic-bdr-stronger: #a6a6a6;
    --semantic-bdr-strongest: #fff;
    --semantic-alert-red-bg-weakest: #560000;
    --semantic-alert-red-bg: #ff4848;
    --semantic-alert-red-bg-hover: #ffd1d1;
    --semantic-alert-red-text: #ff4848;
    --semantic-alert-red-text-strong: #ffeded;
    --semantic-alert-red-icon: #ff4848;
    --semantic-alert-red-icon-inverse: #ff0606;
    --semantic-success-green-bg-weakest: #063522;
    --semantic-success-green-bg: #14bc79;
    --semantic-success-green-text: #11a167;
    --semantic-success-green-text-strong: #e0fcea;
    --semantic-success-green-icon: #14bc79;
    --semantic-success-green-icon-inverse: #11a167;
    --semantic-warning-yellow-bg-weakest: #3e2e00;
    --semantic-warning-yellow-bg: #ebaf00;
    --semantic-warning-yellow-text: #ebaf00;
    --semantic-warning-yellow-text-strong: #fff6da;
    --semantic-warning-yellow-icon: #ebaf00;
    --semantic-warning-yellow-icon-inverse: #d39d00;
    --semantic-info-blue-bg-weakest: #03233f;
    --semantic-info-blue-bg: #45a0f5;
    --semantic-info-blue-text: #45a0f5;
    --semantic-info-blue-text-strong: #e3f3ff;
    --semantic-info-blue-icon: #238ff3;
    --semantic-info-blue-icon-inverse: #0d7fe9;
    --semantic-pretty-brown-text: #a14223;
    --semantic-pretty-brown-text-strong: #f3e2dc;
    --semantic-pretty-brown-bg: #a14223;
    --semantic-pretty-brown-bg-weak: #6e2d18;
    --semantic-pretty-brown-bg-weakest: #512112;
    --semantic-pretty-brown-bg-strong: #ddac9b;
    --semantic-aqua-bg: #0cc;
    --semantic-aqua-text-strong: #e4fafa;
    --semantic-aqua-bg-weak: #006c6c;
    --semantic-aqua-bg-weakest: #004949;
    --semantic-pink-bg: #f4708d;
    --semantic-pink-text-strong: #feecf0;
    --semantic-pink-bg-weak: #b41b3b;
    --semantic-pink-bg-weakest: #660f22;
    --semantic-purple-bg: #9d8fee;
    --semantic-purple-text-strong: #f2f1fd;
    --semantic-purple-bg-weak: #5843d3;
    --semantic-purple-bg-weakest: #322776;
    --semantic-white-bg: #fff;
    --semantic-white-text: #fff;
    --semantic-black-bg: #111;
    --semantic-black-text: #111;
    --semantic-elevation-base: #111;
    --semantic-elevation-top: #222;
    --semantic-opacity-modal: rgba(0, 0, 0, 0.502);
    --semantic-opacity-loading: rgba(0, 0, 0, 0.8);
    --shadow-normal: 0 2px 2px 0 #ffffff14;
    --shadow-inputs-hover-active: inset 0 0 10px 0 #00000029;
    --shadow-inputs-open-dropdown: 0 0 24px 0 #00000029;
    --shadow-buttons-active: 0 0 0 2px #fff;
    --shadow-modals-outer-shadow: 0 0 10px 0 #00000040;
    --shadow-modals-inner-shadow: 0 -2px 4px 0 #ffffff1a;
    --shadow-toggle-normal: 0 4px 6px 0 #00000028;
    --shadow-strong: 0 8px 32px 0 #00000080;
    --shadow-stronger: 0 8px 32px 1px #00000080;
    --component-primary-btn-bg: #ff4e00;
    --component-primary-btn-bg-hover: #c63c00;
    --component-destructive-btn-bg: #db0000;
    --component-destructive-btn-bg-hover: #b00;
    --component-input-bg: #121212;
    --component-input-bg-hover: #303030;
    --component-input-text-placeholder: #888;
    --component-input-bdr: #5e5e5e;
    --component-input-bdr-hover: #d5d5d5;
    --component-select-bg-hover: #303030;
    --component-select-bg-active: #ff4e00;
    --component-select-bg-active-hover: #e64600;
    --component-select-bg-weak: #474747;
    --component-select-bg-weaker: #303030;
    --component-select-alt-bg-hover: #303030;
    --component-select-alt-bg-active: #94bec9;
    --component-select-alt-bg-active-hover: #b0cfd7;
    --component-select-alt-bg-weak: #474747;
    --component-select-alt-bg-weaker: #303030;
    --component-pill-bg: #77acba;
    --component-pill-bg-hover: #94bec9;
    --component-pill-2-bg: #ff4e00;
    --component-pill-2-bg-hover: #e64600;
    --component-pill-3-bg: #e7e7e7;
    --component-pill-3-bg-hover: #fff;
    --component-pill-3-bg-weak: #474747;
    --component-pill-3-bg-weak-hover: #303030;
    --component-navbar-bg: #000;
    --component-navbar-bg-hover: #303030;
    --component-navbar-text-weak: #d5d5d5;
    --component-navbar-bg-avatar: #b0cfd7;
    --component-navbar-fg-hover: #5c1c00;
    --component-navbar-fg-hover-2: #27454d;
    --component-navbar-bdr: #5e5e5e;
    --component-navbar-text-disabled: #888;
    --component-navbar-active-2: #94bec9;
    --component-player-drag: #fff;
    --component-player-bg: #000;
    --component-player-bg-hover: #000;
    --component-player-waveform: #5e5e5e;
    --component-player-waveform-playing: #a6a6a6;
    --component-player-bdr: #222;
    --component-chart-brand-primary: #ff4e00;
    --component-chart-brand-primary-hover: #e64600;
    --component-chart-brand-primary-weakest: #5c1c00;
    --component-chart-brand-primary-weakest-hover: #401300;
    --component-chart-brand-primary-weaker: #a93400;
    --component-chart-brand-primary-weaker-hover: #a93400;
    --component-chart-brand-primary-weak: #c63c00;
    --component-chart-brand-primary-weak-hover: #c63c00;
    --component-chart-brand-primary-medium-weak: #e64600;
    --component-chart-brand-primary-medium-weak-hover: #c63c00;
    --component-chart-brand-primary-medium-strong: #ff6e2e;
    --component-chart-brand-primary-medium-strong-hover: #ff9d72;
    --component-chart-brand-primary-strong: #ff9d72;
    --component-chart-brand-primary-strong-hover: #ffd6c3;
    --component-chart-brand-primary-stronger: #ffd6c3;
    --component-chart-brand-primary-stronger-hover: #ffeee7;
    --component-chart-brand-primary-strongest: #ffeee7;
    --component-chart-brand-primary-strongest-hover: #fff5f1;
    --component-chart-brand-secondary: #5495a6;
    --component-chart-brand-secondary-hover: #77acba;
    --component-chart-brand-secondary-weakest: #1d343a;
    --component-chart-brand-secondary-weakest-hover: #16272b;
    --component-chart-brand-secondary-weaker: #27454d;
    --component-chart-brand-secondary-weaker-hover: #1d343a;
    --component-chart-brand-secondary-weak: #3a6873;
    --component-chart-brand-secondary-weak-hover: #27454d;
    --component-chart-brand-secondary-medium-weak: #457b89;
    --component-chart-brand-secondary-medium-weak-hover: #3a6873;
    --component-chart-brand-secondary-medium-strong: #77acba;
    --component-chart-brand-secondary-medium-strong-hover: #94bec9;
    --component-chart-brand-secondary-strong: #94bec9;
    --component-chart-brand-secondary-strong-hover: #b0cfd7;
    --component-chart-brand-secondary-stronger: #b0cfd7;
    --component-chart-brand-secondary-stronger-hover: #dbeaed;
    --component-chart-brand-secondary-strongest: #dbeaed;
    --component-chart-brand-secondary-strongest-hover: #edf5f7;
    --component-chart-aqua: #0cc;
    --component-chart-aqua-hover: #59e2e2;
    --component-chart-aqua-strong: #b8f2f2;
    --component-chart-aqua-strong-hover: #e4fafa;
    --component-chart-aqua-weak: teal;
    --component-chart-aqua-weak-hover: #009c9c;
    --component-chart-purple: #9d8fee;
    --component-chart-purple-hover: #b6adf4;
    --component-chart-purple-strong: #b6adf4;
    --component-chart-purple-strong-hover: #ddd9fa;
    --component-chart-purple-weak: #5843d3;
    --component-chart-purple-weak-hover: #6b58d8;
    --component-chart-pink: #f4708d;
    --component-chart-pink-hover: #f79baf;
    --component-chart-pink-strong: #f79baf;
    --component-chart-pink-strong-hover: #fcd2db;
    --component-chart-pink-weak: #b41b3b;
    --component-chart-pink-weak-hover: #d22045;
    --component-chart-yellow: #ffca30;
    --component-chart-yellow-hover: #ffe497;
    --component-chart-yellow-strong: #ffe497;
    --component-chart-yellow-strong-hover: #fff6da;
    --component-chart-yellow-weak: #956f00;
    --component-chart-yellow-weak-hover: #b38500;
    --component-chart-blue: #7abbf8;
    --component-chart-blue-hover: #bfe4ff;
    --component-chart-blue-weak: #0b6dc7;
    --component-chart-blue-weak-hover: #0d7fe9;
    --component-chart-green: #3aeb90;
    --component-chart-green-hover: #aef7c9;
    --component-chart-green-weak: #0c7048;
    --component-chart-green-weak-hover: #0e8455;
    --component-chart-orange-strong: #ffd6c3;
    --component-chart-orange-strong-hover: #ffeee7;
    --component-chart-brown-strong: #ddac9b;
    --component-chart-brown-strong-hover: #e9c8bd;
    --component-chart-neutral: #5e5e5e;
    --component-chart-neutral-hover: #303030;
  }
  .light-theme,
  .system-inverted-theme {
    color-scheme: light;
    --semantic-primary-text: #ff4e00;
    --semantic-primary-bg: #ff4e00;
    --semantic-primary-bg-hover: #e64600;
    --semantic-primary-icon: #ff4e00;
    --semantic-primary-bg-weaker: #ffd6c3;
    --semantic-primary-bg-weakest: #ffeee7;
    --semantic-secondary-bg: #77acba;
    --semantic-secondary-bg-hover: #5495a6;
    --semantic-secondary-bg-weaker: #dbeaed;
    --semantic-secondary-bg-weakest: #edf5f7;
    --semantic-text-normal: #111;
    --semantic-text-weak: #474747;
    --semantic-text-weaker: #5e5e5e;
    --semantic-text-disabled: #888;
    --semantic-text-inverse: #fff;
    --semantic-icon-normal: #111;
    --semantic-icon-weak: #474747;
    --semantic-icon-weaker: #5e5e5e;
    --semantic-icon-disabled: #888;
    --semantic-icon-inverse: #fff;
    --semantic-icon-hover: rgba(0, 0, 0, 0.078);
    --semantic-icon-inverse-hover: hsla(0, 0%, 100%, 0.078);
    --semantic-background-base: #fff;
    --semantic-background-middle: #fbfbfb;
    --semantic-background-top: #f0f0f0;
    --semantic-background-raised: #fff;
    --semantic-gray-bg-weakest: #fff;
    --semantic-gray-bg-weakest-hover: #f0f0f0;
    --semantic-gray-bg-weaker: #fbfbfb;
    --semantic-gray-bg-weak: #f0f0f0;
    --semantic-gray-bg-disabled: #f0f0f0;
    --semantic-gray-bg-medium: #d5d5d5;
    --semantic-gray-bg: #888;
    --semantic-gray-bg-strong: #303030;
    --semantic-gray-bg-strong-hover: #000;
    --semantic-gray-bg-strongest: #111;
    --semantic-alert-red-text: #db0000;
    --semantic-alert-red-text-strong: #710000;
    --semantic-alert-red-bg: #db0000;
    --semantic-alert-red-bg-hover: #710000;
    --semantic-alert-red-bg-weakest: #ffeded;
    --semantic-alert-red-icon-inverse: #ff4848;
    --semantic-alert-red-icon: #ff0606;
    --semantic-success-green-bg: #0e8455;
    --semantic-success-green-text: #0e8455;
    --semantic-success-green-text-strong: #084c31;
    --semantic-success-green-bg-weakest: #e0fcea;
    --semantic-success-green-icon-inverse: #14bc79;
    --semantic-success-green-icon: #11a167;
    --semantic-warning-yellow-bg: #b38500;
    --semantic-warning-yellow-text: #d39d00;
    --semantic-warning-yellow-text-strong: #543e00;
    --semantic-warning-yellow-bg-weakest: #fff6da;
    --semantic-warning-yellow-icon-inverse: #ebaf00;
    --semantic-warning-yellow-icon: #d39d00;
    --semantic-info-blue-bg: #0b6dc7;
    --semantic-info-blue-text: #238ff3;
    --semantic-info-blue-text-strong: #053561;
    --semantic-info-blue-bg-weakest: #e3f3ff;
    --semantic-info-blue-icon-inverse: #238ff3;
    --semantic-info-blue-icon: #0d7fe9;
    --semantic-pretty-brown-text: #a14223;
    --semantic-pretty-brown-text-strong: #6e2d18;
    --semantic-pretty-brown-bg: #a14223;
    --semantic-pretty-brown-bg-weak: #f3e2dc;
    --semantic-pretty-brown-bg-weakest: #faf4f1;
    --semantic-pretty-brown-bg-strong: #a14223;
    --semantic-aqua-bg: #00b6b6;
    --semantic-aqua-text-strong: #004949;
    --semantic-aqua-bg-weak: #b8f2f2;
    --semantic-aqua-bg-weakest: #e4fafa;
    --semantic-pink-bg: #eb5a79;
    --semantic-pink-text-strong: #660f22;
    --semantic-pink-bg-weak: #fcd2db;
    --semantic-pink-bg-weakest: #feecf0;
    --semantic-purple-bg: #8d7eeb;
    --semantic-purple-text-strong: #322776;
    --semantic-purple-bg-weak: #ddd9fa;
    --semantic-purple-bg-weakest: #f2f1fd;
    --semantic-bdr-normal: #2e2e2e;
    --semantic-bdr-inverse: #fff;
    --semantic-bdr-weak: #f0f0f0;
    --semantic-bdr-strong: #a6a6a6;
    --semantic-bdr-focus: #111;
    --semantic-bdr-stronger: #888;
    --semantic-bdr-strongest: #111;
    --semantic-white-bg: #fff;
    --semantic-white-text: #fff;
    --semantic-black-bg: #111;
    --semantic-black-text: #111;
    --semantic-elevation-base: #fbfbfb;
    --semantic-elevation-top: #fff;
    --semantic-opacity-modal: rgba(0, 0, 0, 0.251);
    --semantic-opacity-loading: hsla(0, 0%, 100%, 0.8);
    --shadow-normal: 0 2px 2px 0 #00000014;
    --shadow-inputs-hover-active: 0 0 10px 0 #00000029;
    --shadow-inputs-open-dropdown: 0 0 24px 0 #00000029;
    --shadow-buttons-active: 0 0 0 2px #111;
    --shadow-modals-inner-shadow: 0 -2px 4px 0 #0000001a;
    --shadow-modals-outer-shadow: 0 0 10px 0 #00000040;
    --shadow-toggle-normal: 0 4px 6px 0 #00000028;
    --shadow-strong: 0 4px 16px 0 #00000014;
    --shadow-stronger: 0 4px 24px 1px #00000040;
    --component-primary-btn-bg: #ff4e00;
    --component-primary-btn-bg-hover: #c63c00;
    --component-destructive-btn-bg: #db0000;
    --component-destructive-btn-bg-hover: #b00;
    --component-input-bg: #121212;
    --component-input-bg-hover: #f0f0f0;
    --component-input-text-placeholder: #888;
    --component-input-bdr: #d5d5d5;
    --component-input-bdr-hover: #a6a6a6;
    --component-select-bg-hover: #ffeee7;
    --component-select-bg-active: #ff4e00;
    --component-select-bg-active-hover: #c63c00;
    --component-select-bg-weak: #ffd6c3;
    --component-select-bg-weaker: #ffeee7;
    --component-select-alt-bg-hover: #edf5f7;
    --component-select-alt-bg-active: #b0cfd7;
    --component-select-alt-bg-active-hover: #dbeaed;
    --component-select-alt-bg-weak: #dbeaed;
    --component-select-alt-bg-weaker: #edf5f7;
    --component-pill-bg: #b0cfd7;
    --component-pill-bg-hover: #dbeaed;
    --component-pill-2-bg: #ffd6c3;
    --component-pill-2-bg-hover: #ffeee7;
    --component-pill-3-bg: #303030;
    --component-pill-3-bg-hover: #000;
    --component-pill-3-bg-weak: #e7e7e7;
    --component-pill-3-bg-weak-hover: #f0f0f0;
    --component-navbar-bg: #000;
    --component-navbar-bg-hover: #303030;
    --component-navbar-text-weak: #d5d5d5;
    --component-navbar-bg-avatar: #b0cfd7;
    --component-navbar-fg-hover: #5c1c00;
    --component-navbar-fg-hover-2: #27454d;
    --component-navbar-bdr: #5e5e5e;
    --component-navbar-text-disabled: #888;
    --component-navbar-active-2: #94bec9;
    --component-player-drag: #ff4e00;
    --component-player-bg: #fff;
    --component-player-bg-hover: #fbfbfb;
    --component-player-waveform: #f0f0f0;
    --component-player-waveform-playing: #d5d5d5;
    --component-player-bdr: #f0f0f0;
    --component-chart-brand-primary: #ff4e00;
    --component-chart-brand-primary-hover: #e64600;
    --component-chart-brand-primary-weakest: #ffeee7;
    --component-chart-brand-primary-weakest-hover: #fff5f1;
    --component-chart-brand-primary-weaker: #ffd6c3;
    --component-chart-brand-primary-weaker-hover: #ffeee7;
    --component-chart-brand-primary-weak: #ff9d72;
    --component-chart-brand-primary-weak-hover: #ffd6c3;
    --component-chart-brand-primary-medium-weak: #ff6e2e;
    --component-chart-brand-primary-medium-weak-hover: #ff9d72;
    --component-chart-brand-primary-medium-strong: #e64600;
    --component-chart-brand-primary-medium-strong-hover: #c63c00;
    --component-chart-brand-primary-strong: #c63c00;
    --component-chart-brand-primary-strong-hover: #a93400;
    --component-chart-brand-primary-stronger: #a93400;
    --component-chart-brand-primary-stronger-hover: #5c1c00;
    --component-chart-brand-primary-strongest: #5c1c00;
    --component-chart-brand-primary-strongest-hover: #401300;
    --component-chart-brand-secondary: #77acba;
    --component-chart-brand-secondary-hover: #94bec9;
    --component-chart-brand-secondary-weakest: #edf5f7;
    --component-chart-brand-secondary-weakest-hover: #f5fafb;
    --component-chart-brand-secondary-weaker: #dbeaed;
    --component-chart-brand-secondary-weaker-hover: #edf5f7;
    --component-chart-brand-secondary-weak: #b0cfd7;
    --component-chart-brand-secondary-weak-hover: #dbeaed;
    --component-chart-brand-secondary-medium-weak: #94bec9;
    --component-chart-brand-secondary-medium-weak-hover: #b0cfd7;
    --component-chart-brand-secondary-medium-strong: #5495a6;
    --component-chart-brand-secondary-medium-strong-hover: #77acba;
    --component-chart-brand-secondary-strong: #457b89;
    --component-chart-brand-secondary-strong-hover: #3a6873;
    --component-chart-brand-secondary-stronger: #3a6873;
    --component-chart-brand-secondary-stronger-hover: #27454d;
    --component-chart-brand-secondary-strongest: #27454d;
    --component-chart-brand-secondary-strongest-hover: #1d343a;
    --component-chart-aqua: #009c9c;
    --component-chart-aqua-hover: teal;
    --component-chart-aqua-weak: #59e2e2;
    --component-chart-aqua-weak-hover: #0cc;
    --component-chart-aqua-strong: #004949;
    --component-chart-aqua-strong-hover: #003535;
    --component-chart-purple: #8d7eeb;
    --component-chart-purple-hover: #7e6de8;
    --component-chart-purple-weak: #b6adf4;
    --component-chart-purple-weak-hover: #9d8fee;
    --component-chart-purple-strong: #5843d3;
    --component-chart-purple-strong-hover: #322776;
    --component-chart-pink: #eb5a79;
    --component-chart-pink-hover: #e34264;
    --component-chart-pink-weak: #f79baf;
    --component-chart-pink-weak-hover: #f4708d;
    --component-chart-pink-strong: #b41b3b;
    --component-chart-pink-strong-hover: #660f22;
    --component-chart-yellow: #d39d00;
    --component-chart-yellow-hover: #b38500;
    --component-chart-yellow-weak: #ffca30;
    --component-chart-yellow-weak-hover: #ebaf00;
    --component-chart-yellow-strong: #7f5f00;
    --component-chart-yellow-strong-hover: #543e00;
    --component-chart-blue: #238ff3;
    --component-chart-blue-hover: #0d7fe9;
    --component-chart-blue-weak: #7abbf8;
    --component-chart-blue-weak-hover: #45a0f5;
    --component-chart-green: #11a167;
    --component-chart-green-hover: #0e8455;
    --component-chart-green-weak: #3aeb90;
    --component-chart-green-weak-hover: #16d287;
    --component-chart-orange-strong: #a93400;
    --component-chart-orange-strong-hover: #5c1c00;
    --component-chart-brown-strong: #a14223;
    --component-chart-brown-strong-hover: #6e2d18;
    --component-chart-neutral: #d5d5d5;
    --component-chart-neutral-hover: #f0f0f0;
  }

  html:not(.cl-vanilla) {
    -webkit-tap-highlight-color: var(--semantic-background-base);
  }

  .cl-box,
  .cl-text {
    color: var(--semantic-text-normal);
  }
  .cl-box {
    background-color: var(--semantic-background-base);
  }

  html,
  body,
  .BlocksSelect__SelectButtonInner-sc-6l9oql-2 {
    letter-spacing: 0.02em;
  }

  // Override CL global styles
  div[role="alert"] {
    border-radius: 0;

    svg, small {
      color: var(--semantic-text-normal);
    }

    &.alert-message-error {
      background-color: var(--semantic-red-02);
    }
  }

  div[class*="LoadingSplash"] {
    height: 100vh;
    flex: unset;
    background-color: var(--shade-950);

    svg[aria-label="Songtradr"] {
      display: none;
    }
  }


`;
